import * as React from "react";
import { Component } from "react";
import { RuntimeTheme } from "../../../lib/theme/theme";

import { IconContainer, CustomSignInStyle, AppTitle } from "./custom-sign-in-style";
import Img from "../img/img";

import PasswordInput from "./password-input";
import EmailInput from "./email-input";
import NameInput from "./name-input";
import { browserMightBeOniOS } from "../../../../lib/browser-detect";
import { BaseProps } from "./custom-sign-in-props";
import { madeWithGlide } from "common/named-icons-lite";
import { glideViralReferralLink, isEmptyOrUndefinedish } from "common/Support";
import { canShowExternalAuthButtons } from "./google-sso";
import { PlayerContentPlaceholder } from "webapp/glide-app-player.style";
import { getSpinner } from "webapp/chrome/views/activity-spinner/activity-spinner";
import { TailwindThemeProvider } from "sharedUI/lib/tailwind-theme-provider";

interface Props extends BaseProps {
    readonly theme: RuntimeTheme;
}

interface State {
    readonly visualViewportHeight: number | undefined;
}

const MadeWithGlideIcon = madeWithGlide;

class CustomSignInImpl extends Component<Props, State> {
    public state: State = {
        visualViewportHeight: undefined,
    };

    private viewportHandler = (e: any) => {
        this.setState({ visualViewportHeight: e.target.height });
    };

    public componentDidMount() {
        if (window.visualViewport !== undefined && browserMightBeOniOS) {
            (window.visualViewport as any).addEventListener("scroll", this.viewportHandler);
            (window.visualViewport as any).addEventListener("resize", this.viewportHandler);
        }
    }

    public componentWillUnmount() {
        if (window.visualViewport !== undefined && browserMightBeOniOS) {
            (window.visualViewport as any).removeEventListener("scroll", this.viewportHandler);
            (window.visualViewport as any).removeEventListener("resize", this.viewportHandler);
        }
    }

    public render() {
        const {
            theme,
            loginType,
            colorTheme,
            currentState,
            background,
            icon,
            logoSize,
            backgroundOverlay,
            isPro,
            useParallax,
            appTitle,
            appFeatures,
            previewMode,
        } = this.props;
        const { visualViewportHeight } = this.state;
        let buttonOffset = 0;

        if (
            visualViewportHeight !== undefined &&
            window.innerHeight !== visualViewportHeight &&
            window.innerHeight > 500
        ) {
            buttonOffset = window.innerHeight - visualViewportHeight;
            // FIXME: This is a hack to make the virtual keyboard overlap the Sign in with Google
            // button. This only works when there's one external auth button, too.
            // Either make this method report the number of auth buttons we can show or
            // figure out a better way to handle keyboard overlap.
            if (canShowExternalAuthButtons(appFeatures)) {
                buttonOffset -= 66;
            }
        }

        const hasIcon = !isEmptyOrUndefinedish(icon);
        let size = 120;

        if (logoSize !== undefined) {
            if (logoSize === "small") {
                size = 80;
            } else if (logoSize === "medium") {
                size = 100;
            }
        }

        if (currentState === "sign-in") {
            const showBackgroundImage =
                appFeatures?.useCustomSignInBackgroundImageInLoading === true && background !== undefined;
            return (
                <TailwindThemeProvider theme={theme}>
                    <PlayerContentPlaceholder
                        data-test="app-signing-in"
                        backgroundImage={showBackgroundImage ? background : undefined}>
                        {!isPro && <MadeWithGlideIcon fgColor={theme.fgColorDark} />}
                        <div className="spinner">{getSpinner(theme.primaryAccentColor, "loading-placeholder")}</div>
                    </PlayerContentPlaceholder>
                </TailwindThemeProvider>
            );
        }

        // there was a bug where "none" got put in as "no" so treat them the same
        return (
            <CustomSignInStyle
                className={`${
                    backgroundOverlay === undefined ||
                    backgroundOverlay === "none" ||
                    backgroundOverlay === ("no" as any) ||
                    background === undefined
                        ? "accent"
                        : "black"
                }`}
                colorTheme={colorTheme}
                useParallax={useParallax === true && currentState === "challenge"}
                isBuilder={true}
                buttonOffset={buttonOffset}
                previewMode={previewMode}
                role="dialog"
                aria-modal={true}
                aria-labelledby="sign-in-description">
                {background && (
                    <Img
                        className={`bc-background-image ${backgroundOverlay}`}
                        src={background}
                        altBehavior="loading"
                    />
                )}
                <div className="bc-main-content">
                    <div className="bc-content-container">
                        <IconContainer data-test="app-sign-in-icon" size={size}>
                            {hasIcon && <Img src={icon} altBehavior="loading" draggable={false} />}
                            {appTitle !== undefined && !hasIcon && <AppTitle> {appTitle} </AppTitle>}
                        </IconContainer>
                        {loginType === "none" && <NameInput {...this.props} />}
                        {loginType === "password" && <PasswordInput {...this.props} />}
                        {loginType === "email" && <EmailInput {...this.props} />}
                        {isPro === false && (
                            <a
                                className="bc-footer-wrap"
                                href={glideViralReferralLink("sign-in")}
                                rel="noopener noreferrer"
                                target="_blank">
                                <MadeWithGlideIcon />
                            </a>
                        )}
                    </div>
                </div>
            </CustomSignInStyle>
        );
    }
}

const CustomSignIn = CustomSignInImpl;
export default CustomSignIn;
